import { render, staticRenderFns } from "./GetMessagesStatistics.vue?vue&type=template&id=58da81e1&"
import script from "./GetMessagesStatistics.vue?vue&type=script&lang=js&"
export * from "./GetMessagesStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports